module.exports = __webpack_public_path__ + "static/media/Instagram.a0d02930.png";